import {combineReducers} from 'redux';

import commonData from 'app/reducers/commonData';
import gifts from 'pages/Gifts/reducers';

export default (authData: any) => {
    const commonDataReducer = commonData(authData);
    return combineReducers({app: commonDataReducer, gifts});
};
